module.exports = __webpack_public_path__ + "img/new_row_poster.14755a83.png";